import React from "react";
import {List} from "@material-ui/core";
import NavMenuItem from "./NavMenuItem";
import NavSection from "./NavSection";
import NavCollapse from "./NavCollapse";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  sideNavMenu: {
    position: "relative",
    // 以下是修正嵌套菜单sectoin的下划线不显示的问题（3）
    "& > [class^='makeStyles-navSection-']:first-child > .Cmt-navHeader": {
      marginTop: 0,
      borderTop: "none"
    }
  }
}));

const CmtVertical = props => {
  const {menuItems} = props;
  const classes = useStyles();
  return (
    <List component="nav" disablePadding className={classes.sideNavMenu}>
      {menuItems.map((item, index) => {
        if(!item) return;
        switch (item.type) {
          case "section":
            return <NavSection {...item} key={index} />;
          case "collapse":
            return <NavCollapse {...item} key={index} />;
          case "item":
            return <NavMenuItem {...item} key={index} />;
          default:
            return null;
        }
      })}
    </List>
  );
};

export default CmtVertical;
